import type { PricingInput } from '@99designs/graph-utils/types';
import type { Product } from '../../types';

export const getPricingInput = (products: Product[]): PricingInput[] => {
    const pricingInput: PricingInput[] = [];
    products.forEach((product) => {
        if (!product.service.productKey) return;
        if (
            pricingInput.some(
                (input) =>
                    input.service.mpvId === product.service.mpvId &&
                    input.print?.mpvId === product.print?.mpvId
            )
        ) {
            return; // Skip if the product is already included
        }
        pricingInput.push({
            service: product.service,
            print: product?.print,
        });
    });

    return pricingInput;
};
